// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/Users/jiangyichen/Desktop/work/FE-src/third-link/node_modules/_@umijs_runtime@3.5.43@@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "exact": true,
    "path": "/device.html",
    "component": require('@/pages/device').default,
    "title": "工地设备"
  },
  {
    "exact": true,
    "path": "/album.html",
    "component": require('@/pages/album').default,
    "title": "工地快照"
  },
  {
    "exact": true,
    "path": "/live.html",
    "component": require('@/pages/live').default,
    "title": "工地直播"
  },
  {
    "exact": true,
    "path": "/playback.html",
    "component": require('@/pages/playback').default,
    "title": "工地回放"
  },
  {
    "exact": true,
    "path": "/oklive.html",
    "component": require('@/pages/okLive').default,
    "title": "工地直播"
  },
  {
    "exact": true,
    "path": "/playbackHD.html",
    "component": require('@/pages/JFplayback').default,
    "title": "工地回放"
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
